import { FullscreenModal, assets } from '@round/whitelabel-ui';
import styles from './TikTokAudioModal.module.css';
import Audio from './components/Audio/Audio';
import AudioIndicators from './components/AudioIndicators/AudioIndicators';
import Creations from './components/Creations/Creations';
import { UnderLineTabs } from '@round/whitelabel-ui';
import { TabPanel } from '@round/whitelabel-ui';
import TikTokTopPosts from 'Modules/Plans/TopPosts/TikTokTopPosts/TikTokTopPosts';
import cn from 'classnames';

const { Cross: CloseIcon } = assets;

type Props = {
    isOpen: boolean;
    onClose: () => void;
    audioId: number | null | undefined;
};

const STATIC_TAB = 'topPosts';

const TikTokAudioModal = ({ isOpen, onClose, audioId }: Props) => {
    return (
        <FullscreenModal
            isOpen={isOpen}
            onClose={onClose}
            closeOnOverlayClick
            closeOnEscape
            ariaLabel="TikTok Audio Modal"
        >
            <div className={styles.header}>
                <Audio audioId={audioId} />

                <button type="button" className={styles.closeButton} onClick={onClose}>
                    <CloseIcon />
                </button>
            </div>

            <AudioIndicators audioId={audioId} className={styles.content} />
            <Creations audioId={audioId} className={cn(styles.content, styles.charts)} />

            <UnderLineTabs
                //this is static for now until we add more tabs. The tab menu is acting as a section header
                activeTab={STATIC_TAB}
                onChange={() => {}}
            >
                <UnderLineTabs.Menu className={styles.tabs}>
                    <UnderLineTabs.Item name={STATIC_TAB} className={styles.tabItem}>
                        Top Posts
                    </UnderLineTabs.Item>
                </UnderLineTabs.Menu>

                <TabPanel name="topPosts" className={styles.content}>
                    <TikTokTopPosts audioIds={audioId ? [audioId] : []} />
                </TabPanel>
            </UnderLineTabs>
        </FullscreenModal>
    );
};

export default TikTokAudioModal;
